import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header'
import Menu from './menu'
import GamesService from '../services/casinoGamesService'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import '../css/casino/index.css'
import '../css/casino/style.css'
import '../css/casino/responsive.css'
import CasinoCurrencyModal from './sub_components/casinoCurrencyModal';
import { casinoCurrencyList } from '../configs/casinoCurrencyList';
let oid = OPERATOR_ID.toLowerCase()

class DigitainSportBook extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPopup: false,
            operator: OPERATOR_ID,
            digitainToken: '',
            loader: true,
            digitainURL: '',
            host: '',
            hostdom: ''
        };
    }
    componentDidMount() {
        // debugger
        const splited = window.location.host.split('.');
        const host = splited[splited.length - 2];
        const hostdom = splited[splited.length - 1];

        this.setState({
            host: host,
            hostdom: hostdom,
            digitainURL: `https://sport.${host}.${hostdom}/js/Partner/${document.documentElement.clientWidth > 768 ? 'IntegrationLoader.min.js' : 'bootstrapper.min.js'}`, //`https://digitain.${host}.${hostdom}/home${document.documentElement.clientWidth > 768 ? '' : 'M'}.html?token=`
            showPopup: casinoCurrencyList["DIGITAINSPORTSBOOK"].currencyEquals === '1' ? false : true
        }, () => {

            const operator = this.state.operator
            let token = JSON.parse(localStorage.getItem('userAuthDetail'))
            token = !!token ? token.token : null
            if (!!operator && !!token) {
                window.localStorage.setItem("operator", operator);
                window.localStorage.setItem("token", token);
                GamesService.getDigitainSportBook().then((res) => {
                    if (!!res && !!res.data && !!res.data.url) {
                        this.setState({ digitainToken: res.data.url }, () => {
                            this.addDigitainScript();
                        });
                    }
                    this.setState({ loader: false })
                })
            }
        });
    }

    addDigitainScript() {
        const script = document.createElement("script");
        script.type = 'text/javascript';
        script.src = this.state.digitainURL;
        script.async = true;
        script.id = "digiScrpt";
        let digitainToken = this.state.digitainToken;
        script.onload = function () {
            const splited = window.location.host.split('.');
            const host = splited[splited.length - 2];
            const hostdom = splited[splited.length - 1];
            if (document.documentElement.clientWidth > 768) {
                var sp = [
                    ["server", `https://sport.${host}.${hostdom}/`],
                    ["token", digitainToken],
                    ["currentPage", "Home"],
                    ["language", "en"],
                    ["timeZone", "4"],
                    ["isSuperTip", true],
                    ["deposit", "Deposit"],
                    ["oddsFormat", 0],
                    ["oddsFormatList", [1, 2, 3]],
                    ["onContentLoaded", "EventHandler"],
                    ["sportsBookView", "europeanView"],
                    ["fixedHeight", true],
                    ["clearSiteStyles", false],
                    ["theme", "light"],
                    ["parent", [`${host}.${hostdom}`, `digitain.${host}.${hostdom}`]]
                ];
                window['SportFrame'].frame(sp);//SportFrame.frame(sp);
            } else {
                var params = {
                    server: `https://sport.${host}.${hostdom}/`,
                    containerId: "sport_div_iframe",
                    token: digitainToken,
                    defaultLanguage: "en",
                    timeZone: 4,
                    hashRouterDisabled: false,
                    bottomNavBar: true,
                    externalLinksOpenInside: true,
                    oddsFormatList: [1, 2, 3],
                    oddsFormat: 0,
                    theme: "dark",
                    parent: [`${host}.${hostdom}`, `digitain.${host}.${hostdom}`],
                };
                // view: "european",

                window['Bootstrapper'].bootIframe(params, { name: "Mobile" }, { height: "900px" });
            };
        }
        if (!!document.head) {
            document.head.appendChild(script);
        }
    }

    componentWillUnmount() {
        if (!!document.getElementById("digiScrpt")) {
            document.getElementById("digiScrpt").remove();
            if (!!document.getElementById("sport_div_iframe") && !!document.getElementById("sport_div_iframe").children && document.getElementById("sport_div_iframe").children.length > 0) {
                document.getElementById("sport_div_iframe").children[0].remove();
            }
        }
        if (!!document.getElementById("betslip-container-element")) {
            document.getElementById("betslip-container-element").remove();
        }
    }

    hideCurrencyPopup() {
        this.setState({ showPopup: false });
    }
    render() {
        const ismob = document.documentElement.clientWidth > 768 ? false : true;
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} />
                <div className="full-wrap mar-top100 footerpd digitain-mar-top121">
                    {/* <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} /> */}
                    <div className="col-center1 markets ml-0 p-0">
                        <section>
                            <div className={`casino-content-page ${this.state.operator}`} >
                                {this.state.digitainToken === '' ? <>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="loader-bg" style={{ display: this.state.loader ? "flex" : "none" }}>
                                                <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/loader.gif"} className={`${this.state.loader ? "loader-image-active" : "loader-image-active"}`} />
                                            </div>
                                        </div>
                                    </div>
                                </> :
                                    <>
                                        <div id="sport_div_iframe"></div>
                                        {/* <div>
                                        <iframe title={"iframe"} key={"iframe"} style={{ height: "84vh", width: "100%", border: "0px" }} src={`${this.state.digitainURL}${this.state.digitainToken}`}></iframe>
                                    </div> */}
                                    </>
                                }
                            </div>
                        </section>
                    </div>
                    {this.state.showPopup && <>
                        <CasinoCurrencyModal currencyEquals={casinoCurrencyList["DIGITAINSPORTSBOOK"].currencyEquals} fileNM={"sportbookpoint"} hidePopup={() => { this.hideCurrencyPopup() }} />
                        {/* <div id="marketbetspopup" className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                            <div className="modal-dialog modal-sm modal-dialog-centered encasino">
                                <div className="modal-content">
                                    <div className="modal-body engcasinomodalbgimg">
                                        <button onClick={() => { this.setState({ showPopup: false }) }} type="button" className="close text-white ecasinobtnclose" data-dismiss="modal" aria-hidden="true">×</button>
                                        <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/sportbook-popup.png"} className="img-fluid" />
                                        <button type="button" className='virtual-close-btn' onClick={() => { this.setState({ showPopup: false }) }} data-dismiss="modal">&nbsp;</button>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-backdrop fade show" onClick={() => { }}></div>
                        </div> */}
                    </>}
                </div>
            </body>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(DigitainSportBook);